export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8634.02c5fd69.jpg";